<template>
  <div>
    <h2>{{ $t('views.endusers.notes.title') }}</h2>

    <section v-for="section in endUserSections" :key="section.endUserId" class="mb-4">
      <div class="module">
        <div class="module-title">
          <h3>Tenant {{ section.tenantName }}</h3>
        </div>

        <ul v-if="notesFor(section.endUserId).length" class="notes">
          <li v-for="note in notesFor(section.endUserId)" :key="note.id" class="note">
            <div class="note-fg">
              <div class="note-user">{{ note.userName }}</div>
              <div class="note-message">{{ note.text }}</div>
              <div class="note-datetime"><timeago :datetime="note.created" auto-update/></div>

              <div class="note-remove">
                <b-button variant="warning" size="sm" @click="openKillNoteConfirmation(section.endUserId, note)"><b-icon icon="trash"/> entfernen</b-button>
              </div>
            </div>

            <div class="note-bg"></div>
          </li>
        </ul>

        <b-alert v-else variant="info" show class="text-center">
          <b-icon icon="circle-info"/> {{ $t('views.endusers.notes.norecords') }}
        </b-alert>
      </div>

      <div class="module">
        <div class="module-title">
          <h4>{{ $t('views.endusers.notes.add.title') }}</h4>
        </div>

        <note-form :entityKey="endUserEntityKey" :entityId="section.endUserId"/>
      </div>
    </section>

    <b-modal
      :id="noteKillConfirmationModal.id"
      v-model="noteKillConfirmationModal.show"
      size="md"
      centered
      scrollable
      no-fade
      header-bg-variant="warning"
      header-text-variant="black"
    >
      <template #modal-header-close><b-icon icon="close"/></template>
      <template #modal-title>{{ $t('views.endusers.notes.modal.header.title') }}</template>

      <template v-if="noteKillConfirmationModal.show">
        <i18n path="views.endusers.notes.modal.body.confirmation" tag="p">
          <template #br><br></template>
          <template #message><b-badge variant="info" class="text-wrap">{{ noteKillConfirmationModal.item.text.length > 50 ? `${noteKillConfirmationModal.item.text.substr(0, 50)}...` : noteKillConfirmationModal.item.text }}</b-badge></template>
        </i18n>
      </template>

      <template #modal-footer>
        <b-button variant="light" @click="closeKillNoteConfirmation">{{ $t('views.endusers.notes.modal.footer.button.abort') }}</b-button>
        <b-button variant="danger" @click="killNote"><b-icon icon="trash"/> {{ $t('views.endusers.notes.modal.footer.button.confirm') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import MixinEntityBase from '@/components/mixins/EntityBase'
import NoteForm from '@/components/entity/NoteForm'
import MixinEndUserSections from '@/views/EndUsers/_mixins/endUserSections'

const ENDUSER_ENTITY_KEY = 'endcustomerendusers'

export default {
  name: 'EndUsers.Notes',
  mixins: [MixinEntityBase, MixinEndUserSections],
  components: {
    NoteForm
  },
  data () {
    return {
      noteKillConfirmationModal: {
        id: 'noteKillConfirmationModal',
        show: false,
        endUserId: null,
        item: null
      }
    }
  },
  computed: {
    endUserEntityKey () {
      return ENDUSER_ENTITY_KEY
    }
  },
  methods: {
    notesFor (endUserId) {
      return []
        .concat(this.$store.getters[`${ENDUSER_ENTITY_KEY}/getNotesByEndUserId`](endUserId) || [])
        .sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime())
    },
    getNotes (endUserId) {
      this.$store.dispatch(`${ENDUSER_ENTITY_KEY}/getNotes`, endUserId)
    },
    killNote (item) {
      if (!this.noteKillConfirmationModal.endUserId) return
      this.$store.dispatch(`${ENDUSER_ENTITY_KEY}/removeNote`, {
        entityId: this.noteKillConfirmationModal.endUserId,
        note: this.noteKillConfirmationModal.item
      })
      this.closeKillNoteConfirmation()
    },
    openKillNoteConfirmation (endUserId, item) {
      this.noteKillConfirmationModal.item = item
      this.noteKillConfirmationModal.endUserId = endUserId
      this.noteKillConfirmationModal.show = true
    },
    closeKillNoteConfirmation () {
      this.noteKillConfirmationModal.show = false
      this.noteKillConfirmationModal.item = null
      this.noteKillConfirmationModal.endUserId = null
    }
  },
  created () {
    this.$watch('endUserSections', sections => {
      (sections || []).forEach(s => this.getNotes(s.endUserId))
    }, { immediate: true })
  }
}
</script>

<style lang="scss"></style>

